export function copyrightCheckerDossierDetailHref(data, isDomain) {
    if (data == null)
        return;
    if (isDomain) {
        return `/inbreuken/domeinen/${data.id}`;
    }
    return `/inbreuken/dossiers/${data.id}`;
}
